import { cloneBoard, type Board } from '../../engine/board.js';

export interface History {
  push(board: Board): void;
  pop(): Board | undefined;
  clear(): void;
  size(): number;
}

export function createHistory(): History {
  const stack: Board[] = [];
  return {
    push(board) { stack.push(cloneBoard(board)); },
    pop() { return stack.pop(); },
    clear() { stack.length = 0; },
    size() { return stack.length; },
  };
}
